import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "app/helpers/authentication.service";
import { CrudService } from "app/shared/crud-service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { AssinaturasTermosResponse, ExportHistoryTerms } from "./log-termos.model";

@Injectable({
    providedIn: "root",
})
export class UsuarioService extends CrudService<any> {
    routeParams: any;
    grupos: any[] = [];
    grupoAux: any[][];

    constructor(
        protected http: HttpClient,
        private _authService: AuthenticationService,
    ) {
        super(http, `${environment.apiUrl2}/v1/user/`);
    }

    async resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Promise<Observable<any> | Promise<any> | any> {
        this.routeParams = route.params;
        await Promise.all([this.getGrupos()]);
        if (this.routeParams.id === "new") {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getUserById(this.routeParams.id);
        }
    }

    async getGrupos() {
        const response = await this.listAll();
        if (response.length > 0) {
            this.grupos = response.filter((x) => x.status == 1);
            this.grupoAux = response.filter((x) => x.status == 1);
        }
    }

    getUserById(id: string, token?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            if (id) {
                const headers = new HttpHeaders({
                    Authorization: `Bearer ${token}`,
                });

                this.http
                    .get(
                        `${environment.apiUrl2}/v1/user/get-user?userId=${id}`,
                        { headers },
                    )
                    .subscribe((response: any) => {
                        this.data = response;
                        this.onDataChanged.next(this.data);
                        resolve(response);
                    }, reject);
            }
        });
    }

    register(record: any): Promise<any> {
        const headers = new HttpHeaders().set(
            "Content-Type",
            "text/plain; charset=utf-8",
        );

        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.apiUrl2}/v1/user/register`, record, {
                    responseType: "text",
                })
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    changePassword(record: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(
                    `${environment.apiUrl2}/v1/user/change-password`,
                    record,
                    { responseType: "text" },
                )
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    resetPassword(record: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.apiUrl2}/v1/user/reset-password`, record)
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (reject) => resolve(reject),
                );
        });
    }

    ForgetPassword(email: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(
                    `${environment.apiUrl2}/v1/user/forget-password/${email}`,
                    email,
                )
                .subscribe(
                    (response) => {
                        resolve(response);
                    },
                    (reject) => resolve(reject),
                );
        });
    }

    testeLogin(usuario: string, senha: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.apiUrl2}/v1/user/login`, {
                    username: usuario,
                    password: senha,
                    app: "web",
                    local: "web",
                })
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (reject) => {
                        resolve(null);
                    },
                );
        });
    }

    updateUser(record: any, token?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const headers = new HttpHeaders({
                Authorization: `Bearer ${token}`,
            });

            this.http
                .put(`${environment.apiUrl2}/v1/user/edit`, record, {
                    headers,
                    responseType: "text",
                })
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updateUserPreferences(record: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .put(`${environment.apiUrl2}/v1/user/UserPreferences`, record, {
                    responseType: "text",
                })
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    getUserPreferences(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get(
                    `${environment.apiUrl2}/v1/user/UserPreferences?userId=${id}`,
                )
                .subscribe((response: any) => {
                    this.data = response;
                    this.onDataChanged.next(this.data);
                    resolve(response);
                    // console.log(response);
                }, reject);
        });
    }

    validaLogin(token?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const headers = new HttpHeaders({
                Authorization: `Bearer ${token}`,
            });

            this.http
                .get(`${environment.apiUrl2}/v1/user/valida-login?local=web`, {
                    headers,
                })
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (reject) => {
                        resolve(reject);
                    },
                );
        });
    }

    getSignaturesLogs(pageIndex: number, pageSize: number): Observable<AssinaturasTermosResponse> {
        const params = new HttpParams()
            .set("pageIndex", pageIndex)
            .set("pageSize", pageSize);

        return this.http.get<AssinaturasTermosResponse>(
            `${environment.apiUrl2}/v1/termos/assinaturas`,
            { params },
        );
    }

    getUserSignatureHistory(
        userId: string,
        pageIndex: number,
        pageSize: number,
    ): Observable<AssinaturasTermosResponse> {
        const params = new HttpParams()
            .set("userId", userId)
            .set("pageIndex", pageIndex)
            .set("pageSize", pageSize);

        return this.http.get<AssinaturasTermosResponse>(
            `${environment.apiUrl2}/v1/termos/assinaturas/historico`,
            { params },
        );
    }

    acceptTerms(termVersion: number | null, accept?: boolean): Observable<any> {
        return this.http.post(
            `${environment.apiBackStage}/termos/aceite-termos`,
            { termVersion: termVersion, aceiteTermos: accept },
        );
    }

    exportLogs(): Observable<ExportHistoryTerms[]> {
        return this.http.get<ExportHistoryTerms[]>(
            `${environment.apiUrl2}/v1/user/historico-excel`,
        );
    }

    salvaFiltros(objeto): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.apiUrl2}/v1/user/salvar-filtro`, objeto)
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (reject) => {},
                );
        });
    }

    buscaFiltros(identificador: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get(
                    `${environment.apiUrl2}/v1/user/buscar-filtro/${identificador}`,
                )
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (reject) => {
                        resolve("");
                    },
                );
        });
    }

    listAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .post(`${environment.apiUrl2}/v1/user-group/list`, {
                    accountId: this._authService.currentUserValue.accountId,
                })
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    atualizaAcesso(userId: string, token?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const headers = new HttpHeaders({
                Authorization: `Bearer ${token}`,
            });

            this.http
                .post(
                    `${environment.apiUrl2}/v1/user/set-last-web-access`,
                    { userId: userId },
                    { headers, responseType: "text" },
                )
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
}
